<template lang="html">
  <div id="app">
    <el-container>
      <el-header class="div-header">
        <Header />
        <el-divider class="header-divider"></el-divider>
      </el-header>
      <div class="main-div">
        <el-container class="main-div parentDiv">
          <splitpanes class="default-theme defaultStyle custom-splite">
            <pane size="100" class="SideBarLeft">
                <!--SID1021 Body Part-->
                <template>
                  <el-container class="SID1021__Condition">
                      <div id="SID1021__Container">
                            <el-breadcrumb separator-class="el-icon-arrow-right">
                              <el-breadcrumb-item :to="{ path: '0002' }">トップ(記事一覧)</el-breadcrumb-item>
												<el-breadcrumb-item :to="{ path: '' }"> 記事件数確認条件設定</el-breadcrumb-item>
												<!-- <el-breadcrumb-item :to="{ path: '' }">記事件数確認条件設定</el-breadcrumb-item> -->
											</el-breadcrumb>
                        <div class="MailDeliveryDestinationList-form"> 
                          <div class="labelTitle">  
                            <el-form ref="form" :rules="rules"  :model="form" class="div-form" label-width="auto">
                              <el-form-item class="el-lbl-content" label="表示方法" >
                                <el-radio v-model=form.radio label="0">日間</el-radio>
                                <el-radio v-model=form.radio label="1">月間</el-radio>
                              </el-form-item>																																																	
                              <el-form-item prop="getperoiddate_id" label="集計期間" class="ArticleSearchInnerItem1">
                                <!-- Change by CK for backlog Id: 1440 for calendar input  only by clicking  -->
                              <v-date-picker 
                                  v-model="form.getperoiddate_id"                                                            
                                  mode="range"
                                  locale="ja"
                                  :masks="{ title: 'YYYY年MMM' }"
                                  :available-dates='{ start: date_min, end: null }'
                                  :popover="{  visibility: 'click' }"
                                  :input-props='{readonly : true}'
                                  :update-on-input='true'>
                                  <input slot-scope="{ inputProps, inputEvents }"          
                                  v-bind="inputProps"
                                  v-on="inputEvents" />
                                 </v-date-picker>                             
                              </el-form-item>	
                              <el-form-item>
                                <el-button @click="onSubmit('form')" type="primary" plain>照会 </el-button>
                              </el-form-item>												
                            </el-form>                   
                          </div> 
                        </div>
                      </div>
                  </el-container>
                </template>
                <!--SID1021 Body Part End-->
            </pane>
            <pane class="SideBarRight">
              <SideBar class="SidePane" />
            </pane>
          </splitpanes>
        </el-container>
      </div>
      <el-container class="footer-div">
        <el-footer class="footer-element">
          <FooterComponent />
          </el-footer>
      </el-container>
    </el-container>
  </div>
</template>

<script lang="js">
import Header from "../common/header.vue";
import SideBar from "../common/side-bar.vue";
import FooterComponent from "../common/footerComponent.vue";
import router from '../../router';
import { mapGetters } from "vuex";
// In your VueJS component.
import { Splitpanes, Pane } from "splitpanes";
import "splitpanes/dist/splitpanes.css";
//import Common from '../../common/CommonFunc.js'
var CurrentYear = new Date().getFullYear();
var CurrentMonth = new Date().getMonth();
var CurrentDay = new Date().getDate();

//This is for disabling the days before one year and half month(18months)
var d = new Date();
d.setMonth(d.getMonth() - 18);


  export default  {
    name: 'SID1021',
    components: {
		Header,
		SideBar,
		FooterComponent,
		Splitpanes,
    Pane
	},
    
    mounted () {

    },
   
    data () {
     return {
        date_min:d,
        form: {
        radio: '0',
        getperoiddate_id: {
          start: new Date(CurrentYear,CurrentMonth, CurrentDay), // Jan 16th, 2018
          end: new Date(CurrentYear, CurrentMonth, CurrentDay) // Jan 19th, 2018
        },
        },
       
        date: new Date(),
        rules:{
          getperoiddate_id: [
                { required: true, message: '集計期間を指定してください。', trigger: 'blur' }
                
            ],
        }
      }
    },
    computed: {
      ...mapGetters("situation1021", [
           "getform1021"]),
			...mapGetters("validationHandler", [
			"getRules",
		]),
	},
    methods: {
      onSubmit(formName) {
      this.$LogButtonEvent("1021","Inquiry");
      this.$LogMethodIN("1021","onSubmit");
			this.$refs[formName].validate((valid) => {
			if (valid) {
        //To get the start date
        var startingDate=this.form.getperoiddate_id.start;
        var splitData = new Date(startingDate),
        splitmonth = ("0" + (splitData.getMonth() + 1)).slice(-2),
         splitday = ("0" + splitData.getDate()).slice(-2);
        var startResult = [splitData.getFullYear(), splitmonth, splitday].join("/");
        
         //To get the end date
        var getlastDate=this.form.getperoiddate_id.end;
      
        var splitDataLast = new Date(getlastDate),
         splitmonthlast = ("0" + (splitDataLast.getMonth() + 1)).slice(-2),
         splitdaylast = ("0" + splitDataLast.getDate()).slice(-2);
        var startResultlast = [splitDataLast.getFullYear(), splitmonthlast, splitdaylast].join("/");
       
        
        var radio_selected= this.form.radio;
       
        router.push({
          name: "1022",
          query: {
             process_date_from: startResult,
             process_date_to:startResultlast,
             method:radio_selected
             }
        });
           
			} else {
				return false;
			}
      });
      this.$LogMethodOut("1021","onSubmit");
		
		},
    
    },
    beforeCreate(){
      //Common.Session.CheckSessionExists_IfExpired_GoToLogout();
    },
    created(){
      //For the screen Title
     document.title = "記事件数確認条件設定画面";
      
    }
}
</script>

<style scoped>
@import "1021.css";
</style>